import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let template_id = useDataValue({
    context: 'profile_patient_referral',
    path: 'referral_template_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { template_id },
  }
}
